<template>
    <v-menu offset-y v-if="inspection">
        <template v-slot:activator="{ on, attrs }">
            <a
                v-bind = "attrs"
                v-on   = "on"
                class  = "audit-menu"
            >
                <v-icon color="white" size="24">mdi-menu</v-icon>
            </a>
        </template>

        <div class="white">
            <v-list class="white">
                <v-list-item
                    v-for = "(entry, index) in menu"
                    :key  = "index"
                    link
                >
                    <v-list-item-title
                        @click = "onMenu(entry)"
                        class  = "v-flex"
                    >
                        <div style="margin-top: -2px; margin-right: 8px;">
                            <v-icon
                                size   = "18"
                                :color = "entry.available ? 'black' : 'secondary'"
                            >
                                {{ entry.icon }}
                            </v-icon>
                        </div>

                        <div
                            style  = "width: 110px"
                            :class = "entry.available ? 'black--text' : 'secondary--text'"
                        >
                            {{ entry.name }}
                        </div>

                        <div
                            v-if   = "!isImage (entry) && entry.available"
                            class  = "menu-status"
                        >
                            <v-icon size="24" :color="statusColor (entry.status)">{{ statusIcon (entry.status) }}</v-icon>
                        </div>

                        <div
                            v-if   = "isImage(entry)"
                            :class = "entry.available ? 'black--text' : 'secondary--text'"
                        >
                            {{ entry.data.length + " Bilder" }}
                        </div>
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </div>
    </v-menu>

</template>

<script>
import Disposition from "@/modules/dis/service/Disposition";

export default {
    name: "CInspectionMenu",

    props: {
        inspection: {

        }
    },

    data: () => ({
        menu: null
    }),

    computed: {
        areas () {
            return Disposition.inspection.areas;
        }
    },

    mounted() {
        this.initialize();
    },

    watch: {
        inspection () {
            this.initialize();
        }
    },

    methods: {
        initialize () {
            if (!this.inspection) {
                return;
            }

            this.menu = Disposition.inspection.menu(this, this.inspection);

            this.menu.unshift({
                id       : "CONTACTS",
                name     : "Kontakte",
                icon     : "mdi-account-multiple",
                status   : null,
                available: true,
                data     : null
            });
        },

        onMenu(entry) {
            if (!entry.available) {
                return;
            }

            this.$emit("menu", entry);
        },

        isImage (entry) {
            return entry.id === this.areas.IMAGES || entry.id === this.areas.BOOK;
        },

        statusColor (status) {
            switch (status) {
                case "CREATED":
                    return null;
                case "IN_PROCESS":
                    return "grey";
                case "PROCESS_DONE":
                    return "grey";
                case "TRANSFER_DONE":
                    return "success"
                default:
                    return "black";
            }
        },

        statusIcon (status) {
            switch (status) {
                case "CREATED":
                    return null;
                case "IN_PROCESS":
                    return "mdi-pencil-box";
                case "PROCESS_DONE":
                    return "mdi-thumb-up";
                case "TRANSFER_DONE":
                    return "mdi-thumb-up"
                default:
                    return null;
            }
        }
    }
}
</script>

<style scoped>

.menu-status {
    margin-top: -2px;
}

::v-deep .v-list-item .v-list-item__subtitle, .v-list-item .v-list-item__title {
    line-height: 2.2;
}

</style>